import { createPortal } from "react-dom";
import cross from "../assets/svgs/cross.svg";
import { ReactSVG } from "react-svg";
import updateno from "../assets/images/updateno.png";
import Button from "./form/Button";
import { Link, useNavigate } from "react-router-dom";
import Session from "../utils/sessionStorage";

const Prompt = ({ call, close }) => {
  const result = Session.get("_user_");
  const userData = result ? JSON.parse(result) : "";
  // const navigate = useNavigate();
  console.log(userData.customerType, "costumer type")
  const userType = userData.customerType;

  const saOrgName = userData?.saOrgName;

  const handleBackToMainApp = () => {

    window.location.href = `https://uat.onepay.com.my/dl/${saOrgName}/?OpName=Close`;
  };

  const handleBackToPremiumApp = () => {
    window.location.href = `https://uat.onepay.com.my/dl/${saOrgName}/?OpName=GoPremium`;
  };

  return createPortal(
    <div className=" overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 flex justify-center items-center h-full w-full md:inset-0  max-h-full bg-black bg-opacity-50">
      <div className="relative p-4 w-full max-w-md max-h-full">
        <div className="relative px-7 py-6 bg-white rounded-lg shadow ">
          <div className="absolute top-3 right-5">
            {call === "onLink" && (
              <button
                type="button"
                className="end-2.5  text-gray-400 cursor-pointer hover:bg-gray-200  rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center  "
                onClick={close}
              >
                <ReactSVG src={cross} />
                <span className="sr-only">Close modal</span>
              </button>
            )}
          </div>
          <div className="relative mt-5 p-4">
            <div className="">
              <div className="mx-auto size-36">
                <img src={updateno} alt="update no" className="w-full h-full" />
              </div>
              {call === "notXoxUser" && (
                <>
                  <p className="font-poppins text-sm font-normal text-center text-accent-silver-900 pb-1">
                    To avail cashback update s4s number in super app.
                  </p>
                  <p className="font-poppins text-sm font-normal text-center text-accent-silver-900 pb-8">
                    For sim purchase please email us at{" "}
                    <strong>info@s4s.my</strong>
                  </p>
                  {/* <Link
                    to={"/selfregister"}
                    className="flex w-fit mx-auto justify-center items-center font-poppins bg-primary text-white py-1 px-7 rounded-3xl active:scale-95 transition transform duration-150"
                  >
                    Self Register
                  </Link> */}
                </>
              )}
              {call === "onLink" && (
                <>
                  {userType === "REG" ? (
                    <>
                      <p className="font-poppins text-sm font-normal text-center text-accent-silver-900 pb-4">
                        Your application is being processed.
                      </p>
                      <div className="flex justify-center mt-4">
                        <Button
                        children={"Close"}
                        intent={"primary"}
                        size={"md"}
                        roundness={"round"}
                        classes={"mx-auto"}
                        eventAction={close}
                      />
                      </div>
                    </>
                  ) : (
                    <>
                      <p className="font-poppins text-sm font-normal text-center text-accent-silver-900 pb-4">
                        To use this feature, please upgrade to Premium
                      </p>
                      <Button
                        children={"Upgrade to Premium"}
                        intent={"primary"}
                        size={"md"}
                        roundness={"round"}
                        classes={"mx-auto"}
                        eventAction={handleBackToPremiumApp}
                      />
                    </>
                  )}
                </>
              )}

              {call === "home" && (
                <>
                  <p className="font-poppins text-sm font-normal text-center text-accent-silver-900 pb-1">
                    Only S4S number user is able to access this mini app.
                  </p>
                  <p className="font-poppins text-sm font-normal text-center text-accent-silver-900 pb-8">
                    For sim purchase, please email us at{" "}
                    <strong>info@s4s.my</strong>
                  </p>
                  <Button
                    children={"Back to Wallet"}
                    intent={"primary"}
                    size={"md"}
                    roundness={"round"}
                    classes={"mx-auto"}
                    eventAction={handleBackToMainApp}
                  />
                </>
              )}

            </div>
          </div>
        </div>
      </div>
    </div>,

    document.body
  );
};

export default Prompt;
